import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

export default function FolderTicket({
  link = "/tickets",
  text = "TICKETS",
  delay = 0,
}) {
  const [isPopped, setIsPopped] = useState(false);

  // Auto-animate every 3.5 seconds - pop up for 2 seconds, then down for 1.5 seconds
  useEffect(() => {
    let interval;

    const timeout = setTimeout(() => {
      setIsPopped(true);

      interval = setInterval(() => {
        setIsPopped(true);
        // Stay up for 2 seconds, then down for 1.5 seconds
        setTimeout(() => {
          setIsPopped(false);
        }, 2000);
      }, 3500);
    }, delay);

    return () => {
      clearTimeout(timeout);
      if (interval) clearInterval(interval);
    };
  }, [delay]);

  return (
    <Link to={link} className="cursor-pointer ">
      <svg
        className="w-full h-full max-w-[200px] sm:max-w-[250px] md:max-w-[300px] lg:max-w-[350px]"
        viewBox="0 0 100 85"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMidYMid meet"
      >
        <path
          className="folder-back"
          d="M10,15 L40,15 L45,20 L90,20 C92.76,20 95,22.24 95,25 L95,75 L5,75 L5,20 C5,17.24 7.24,15 10,15 Z"
          fill="#fef08a"
        />

        <g
          className="ticket-group"
          style={{
            transform: isPopped ? "translateY(-20px)" : "translateY(0)",
            transition: "transform 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
          }}
        >
          <path
            d="M25,30 L75,30 L75,45 A 5,5 0 0 0 75,55 L75,70 L25,70 L25,55 A 5,5 0 0 0 25,45 L25,30 Z"
            fill="#7c3aed"
            stroke="#6d28d9"
            strokeWidth="1"
          />

          <line
            x1="28"
            y1="50"
            x2="72"
            y2="50"
            stroke="#ffffff"
            strokeWidth="1"
            strokeDasharray="3,2"
            opacity="0.5"
          />

          <text
            x="50"
            y="50"
            className="ticket-text"
            textAnchor="middle"
            fill="#ffffff"
            fontSize="8"
            fontFamily="Neuehaasdisplay, sans-serif"
            fontWeight="700"
          >
            {text}
          </text>
        </g>

        <path
          className="folder-front"
          d="M5,80 L95,80 C97.76,80 100,77.76 100,75 L95,35 C95,32.24 92.76,30 90,30 L10,30 C7.24,30 5,32.24 5,35 L0,75 C0,77.76 2.24,80 5,80 Z"
          fill="#fde047"
        />
      </svg>
    </Link>
  );
}
